import React from 'react';


const CurveLineCTA = ({ secTitle, children }) => {
  return (

    <div className="curve-line-cta__wrapper">
      {secTitle &&
        <div className="centered-content">
          <h2 className='text-head font-22 bold txt-blue'>{secTitle}</h2>
        </div>
      }
      <div className="curve-line-cta">
        <div className="centered-content border-wrap">
          <div className="svg-container">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1398 48" fill="none" className="cta-svg">
              <path d="M2 47.464C2 2 47.4054 2 47.4054 2L1397.5 2" stroke="#90D21F" strokeWidth="4" />
            </svg>
          </div>
          <div className="curve-line-cta__content">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurveLineCTA;
